import styled from 'styled-components';

export const InputWrapper = styled.div`
  height: 48px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 14px;
  padding: 11px 10px;

  div:not(:has(input)) {
    top: 2px;
  }

  input {
    padding: 0;
    margin: 0;
    border: none;
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: 306px;
  }
`;
